import React, { useEffect, useState } from "react";
import { db } from "../firebase-config"; // Ensure db is correctly initialized
import { collection, getDocs, query, orderBy, updateDoc, doc } from "firebase/firestore";

function ViewReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const reportsCollection = collection(db, "reports");
        const reportsQuery = query(reportsCollection, orderBy("createdAt", "desc")); // Order by createdAt
        const querySnapshot = await getDocs(reportsQuery);

        const reportsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setReports(reportsList);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching reports:", error);
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  const toggleIssueResolved = async (reportId, currentStatus) => {
    try {
      const reportDoc = doc(db, "reports", reportId);
      await updateDoc(reportDoc, {
        issueResolved: !currentStatus, // Toggle the issueResolved value
      });
      // Optionally, update the local state to reflect the change without refetching
      setReports((prevReports) =>
        prevReports.map((report) =>
          report.id === reportId
            ? { ...report, issueResolved: !currentStatus }
            : report
        )
      );
    } catch (error) {
      console.error("Error updating report status:", error);
    }
  };

  return (
    <div>
      <h1>Reported Issues</h1>

      {loading ? (
        <p>Loading reports...</p>
      ) : (
        <div>
          {reports.length === 0 ? (
            <p>No reports found.</p>
          ) : (
            <ul>
              {reports.map((report) => (
                <li key={report.id} style={{ marginBottom: "20px" }}>
                  <h3>{report.name}</h3>
                  <p><strong>Email:</strong> {report.email}</p>
                  <p><strong>Issue:</strong> {report.issue}</p>
                  <p><strong>Reported At:</strong> {new Date(report.createdAt.seconds * 1000).toLocaleString()}</p>
                  <p><strong>Type:</strong> {report.type}</p>
                  <p>
                    <strong>Status:</strong> {report.issueResolved ? "Resolved" : "Unresolved"}
                  </p>
                  <button onClick={() => toggleIssueResolved(report.id, report.issueResolved)}>
                    Mark as {report.issueResolved ? "Unresolved" : "Resolved"}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default ViewReports;
